import { useEffect, useState } from "react";

/**
 * Slim fixed reading-progress bar that fills as the user scrolls
 * the page. Uses transform-friendly width updates with rAF
 * throttling for smooth, performant tracking.
 */
const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let rafId: number | null = null;

    const update = () => {
      rafId = null;
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / docHeight) * 100)) : 0;
      setProgress(pct);
    };

    const onScroll = () => {
      if (rafId === null) rafId = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (rafId !== null) window.cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      className="reading-progress"
      /* scaleX instead of width: the bar updates on every scroll frame, and a
         transform is composited rather than triggering layout each time. */
      style={{ transform: `scaleX(${progress / 100})` }}
      aria-hidden="true"
      role="presentation"
    />
  );
};

export default ReadingProgress;
